import { useRef, useState } from "react";
import { ImagePlus, X } from "lucide-react";
import api from "../lib/api";

export const imgSrc = (u) => (u ? `${process.env.REACT_APP_BACKEND_URL}${u}` : null);

export default function LogoUpload({ url, onChange, testid = "logo-upload" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!f.type.startsWith("image/")) return setErr("Vælg et billede (JPG, PNG eller WebP).");
    if (f.size > 2 * 1024 * 1024) return setErr("Billedet må højst fylde 2 MB.");
    setErr(""); setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const r = await api.post("/uploads/image", fd);
      onChange(r.data.logo_id, r.data.url);
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Upload fejlede – prøv igen.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="lu" data-testid={testid}>
      <span className="lu-prev">{url ? <img src={imgSrc(url)} alt="Logo" data-testid={`${testid}-preview`} /> : <ImagePlus size={20} />}</span>
      <div className="lu-actions">
        <button type="button" className="btn small" onClick={() => ref.current?.click()} disabled={busy} data-testid={`${testid}-btn`}>
          {busy ? "Uploader…" : url ? "Skift billede" : "Upload logo eller foto"}
        </button>
        {url && <button type="button" className="btn small ghost" onClick={() => onChange(null, null)} data-testid={`${testid}-remove`}><X size={14} /> Fjern</button>}
        <small className="muted">Valgfrit · billede op til 2 MB · beskæres kvadratisk</small>
        {err && <small className="lu-err" role="alert" data-testid={`${testid}-error`}>{err}</small>}
      </div>
      <input ref={ref} type="file" accept="image/*" hidden onChange={pick} data-testid={`${testid}-input`} />
    </div>
  );
}
